import autoload from "./autoload";
import auth from "./mixins/auth";
import cart from "./mixins/cart";
import applicatorLinks from "./mixins/applicator";
import initDom from "./mixins/init_dom";
import project from "./mixins/project";
import GalleryEditModal from "./components/modals/GalleryEditModal";
import GalleryReviewModal from "./components/modals/GalleryReviewModal";
import ApplicatorReviewModal from "./components/modals/ApplicatorReviewModal";

autoload();

window.app = new Vue({
  el: "#vue-gallery-details",

  mixins: [initDom, auth, cart, applicatorLinks, project],

  components: {
    GalleryEditModal,
    GalleryReviewModal,
    ApplicatorReviewModal,
  },

  data() {
    return {
      project: window._PR?.project || {},
      applicatorId: window._PR?.project?.applicator?.id || "",
      pinnedProjects: [],
      hasReview: window._PR?.hasReview || false,
      reviewType: "",
    };
  },

  computed: {
    isProjectOwner() {
      if (
        this.isLoggedIn &&
        this.project.applicator.customer_id === this.me.customer_id
      ) {
        return true;
      }

      return false;
    },

    pinnedProjectIds() {
      return this.pinnedProjects.map((project) => `${project.id}`);
    },

    projectHasReview() {
      return (
        this.hasReview ||
        this.project.review_requested ||
        this.project.approval_type.includes(["needs_review", "reviewed_denied"])
      );
    },
  },

  created() {
    this.getPinnedProjects();
  },

  methods: {
    reviewProject(type) {
      if (type !== undefined) {
        this.reviewType = type;
      }

      setTimeout(() => $("#applicatorReviewModal").modal("show"), 150);
    },

    async getPinnedProjects() {
      this.pinnedProjects = [];

      const response = await axios.get(
        `/api/proxify/user-public-profiles/${this.project.applicator.id}/feed?domain=${this.$root.domain}&limit=4&pinned_status=pinned_only`
      );

      this.pinnedProjects.push(...response.data);
    },

    // !IMPORTANT: if we start using pinned/edit project functionality more throughout the site then we'll probably want to convert these 👇 into a mixin.

    /**
     * @param {object|number|string} project The project being edited.
     * @returns {Promise<void>}
     */

    async editProject() {
      this.$refs.reloadEdit.reloadEditModal(this.project);
      setTimeout(() => $("#galleryEditModal").modal("show"), 100);
    },

    editedProject(item) {
      this.project = item;
      window.location = "/project-gallery";
    },

    /**
     * @param {number|string} id
     * @returns {Promise<void>}
     */

    async pinProject(id) {
      try {
        await axios.put(`/api/proxify/projects/${id}/pin`.replace("{id}", id));
        await this.getPinnedProjects();

        this.$root.$refs.notifications.add({
          type: "success",
          icon: "check",
          title: "Project successfully pinned",
          message: "The selected item was added to your Featured Work feed.",
        });
      } catch (error) {
        console.error(error);

        this.$root.$refs.notifications.add({
          type: "error",
          icon: "exclamation-triangle",
          title: "Something went wrong",
          message: `Unable to add the selected item to your Featured Work feed.
          Please contact customer support if you continue having this issue.`,
        });
      }
    },

    /**
     * @param {number|string} id
     * @returns {Promise<void>}
     */

    async unpinProject(id) {
      try {
        await axios.delete(
          `/api/proxify/projects/${id}/pin`.replace("{id}", id)
        );
        await this.getPinnedProjects();

        this.$root.$refs.notifications.add({
          type: "success",
          icon: "check",
          title: "Un-pinned",
          message:
            "The selected item was removed from your Featured Work feed.",
        });
      } catch (error) {
        this.$root.$refs.notifications.add({
          type: "error",
          icon: "exclamation-triangle",
          title: "Something went wrong",
          message: `Unable to remove the selected item from your Featured Work feed.
          Please contact customer support if you continue having this issue.`,
        });
      }
    },

    /**
     * @param {number|string} id
     * @returns {Promise<void>}
     */
    async deleteProject(id) {
      if (confirm(`Are you sure you want to delete the selected project?`)) {
        try {
          if (this.itemIsPinned(id)) await this.unpinProject(id);

          await axios.delete(
            `/api/proxify/domains/${this.$root.domain}/projects/${id}`
          );

          this.$root.$refs.notifications.add({
            type: "success",
            icon: "check",
            title: "Project deleted",
            message: "The selected project was successfully deleted.",
          });

          window.location = "/project-gallery";
        } catch (error) {
          console.error(error);

          this.$root.$refs.notifications.add({
            type: "error",
            icon: "exclamation-triangle",
            title: "Something went wrong",
            message: `Unable to delete the selected project.
            Please contact customer support if you continue having this issue.`,
          });
        }
      }
    },

    itemIsPinned(id) {
      return this.pinnedProjects.includes(id);
    },
  },
});

// displays the add-to-cart dropdown
require("./app_events");
